export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sources"])},
        "courseSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sources of the imgages used for the courses."])},
        "testSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sources of the images used for the tests."])},
        "taskSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sources for the images used in the tasks."])},
        "result": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Result"])},
        "task": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Task"])}
      },
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bronnen"])},
        "courseSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bronnen van de afbeeldingen die zijn gebruikt voor de cursussen."])},
        "testSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bronnen van de afbeeldingen die voor de tests zijn gebruikt."])},
        "taskSources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bronnen voor de afbeeldingen die in de taken worden gebruikt."])},
        "result": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultaat"])},
        "task": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taak"])}
      }
    }
  })
}
